import { Placeholder as P } from "react-bootstrap";

export const Placeholder = () => (
  <P as="p" animation="glow">
    <P xs={12} />
  </P>
);
